/**
 * Update date: 31-05-2023
 * Screen 2051.2
 */
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import useAxios from 'axios-hooks';
import ArrayStore from 'devextreme/data/array_store';
import { useProductType } from 'hooks/useProductType';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { dateFormatStr } from 'utils/format';
import FormSearch from './FormSearch';
import { BreadCrumbPremium } from 'app/components/BreadCrumbPremium';

const List = React.lazy(() => import('./ListInvetory'));
const Detail = React.lazy(() => import('./Detail'));

const defaultParamsInstock = {
  largeCategory: '',
  subCategory: '',
  mediumCategory: '',
  smallCategory: '',
  product: '',
  productGroup: '',
  inStock: '',
  productType: '',
  zone: '',
};
/**
 * create context
 */
const InventoryReceivingContext = createContext({
  refetchData: () => {},
});

InventoryReceivingContext.displayName = 'InventoryReceivingContext';

export const useInventoryReceiving = () => {
  const context = useContext(InventoryReceivingContext);
  return context;
};

function InventoryReceivingAndForwarding(props) {
  const { productTpPermission, loadingProductTpPermission }: any =
    useProductType();
  const [modeView, setModeView] = useState({
    type: 'list',
    data: null,
  });
  const [params, setParams] = useState({
    ...defaultParamsInstock,
    startDuration: new Date(),
    endDuration: new Date(),
    formStore: {
      largeCategory: [],
      subCategory: [],
      mediumCategory: [],
      smallCategory: [],
      product: [],
      productGroup: [],
      productType: [],
      zone: [],
    },
  });
  const [{ data, loading }, refetchData] = useAxios(
    {
      url: '/warehouse/instock/transport',
      method: 'POST',
    },
    { manual: true, useCache: false },
  );

  const dateFrom = dateFormatStr(params?.startDuration);
  const dateTo = dateFormatStr(params?.endDuration);
  const store: any = new ArrayStore({
    data: data?.data?.map((o, i) => ({
      ...o,
      id: i,
      dateFrom,
      dateTo,
    })),
    key: 'id',
  });
  /**
   * fetch data
   */
  useEffect(() => {
    if (!productTpPermission?.length) return;
    setParams(preState => ({
      ...preState,
      formStore: {
        ...preState?.formStore,
        productType: productTpPermission,
      },
      isReadOnlyProductTp: productTpPermission?.length > 0,
    }));
  }, [productTpPermission]);

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return (
          <>
            <BreadCrumbPremium />
            <FormSearch />
            <List />
          </>
        );
      case 'detail':
        return <Detail />;
      default:
        return <NotFoundPage />;
    }
  };

  const value: any = {
    modeView,
    setModeView,
    store,
    params,
    setParams,
    refetchData,
  };
  const loadingAll = loading || loadingProductTpPermission;
  return (
    <InventoryReceivingContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loadingAll} />
        {renderContent()}
      </React.Suspense>
    </InventoryReceivingContext.Provider>
  );
}

export default InventoryReceivingAndForwarding;
